import PropTypes from 'prop-types';
// material
import { Divider, List, ListItemButton, Stack, Tooltip, Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import moment from 'moment';
import { Fragment } from 'react';
import { calculNbG, speedConverter } from '../../common/utils/unitConverter';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectSession } from '../../createSelectorUtils';
// utils

FlightReviwRoulage.propTypes = {
  positions: PropTypes.array,
  analyse: PropTypes.object,
  state: PropTypes.object,
  setState: PropTypes.func,
  device: PropTypes.object
};
export default function FlightReviwRoulage({ analyse, positions, state, setState, device }) {
  const t = useTranslation();
  const session = useSelector(selectSession);
  return (
    <List>
      {analyse.analyseRoulageReports.map((roulage, index) => (
        <Fragment key={index}>
          <ListItemButton
            selected={state.selectedListItem === index}
            onClick={() => {
              setState({
                ...state,
                selectedListItem: index,
                currentPosition: positions.indexOf(
                  positions.find((item) => item.id === roulage.startPositionId)
                )
              });
            }}
            key={`info-${index}`}
          >
            <Stack direction="column" key={`stackInfo-${index}`}>
              <Typography variant="subtile1">{`n° ${index + 1} - ${moment(
                positions.find((item) => item.id === roulage.startPositionId).fixTime
              ).format('HH:mm:ss')}`}</Typography>
              {roulage.distance > 0 && (
                <Typography variant="subtitle1">
                  {`${t('DB_Distance')}: ${roulage.distance.toFixed(0)} m`}
                </Typography>
              )}
              <Typography variant="subtitle1">
                {`${t('FR_Details_Duration')} (mm:ss): ${moment(roulage.duration).format('mm:ss')}`}
              </Typography>
            </Stack>
          </ListItemButton>
          {roulage.speedAlert ? (
            <Tooltip
              title={` ${t('FR_Details_LimitMessage')} (
                ${speedConverter(device.speedMaxRoulage, session.uniteVitesse)} ${
                  session.uniteVitesse
                })`}
              placement="top"
              key={`speedAlert-${index}`}
            >
              <ListItemButton
                selected={state.selectedListItem === index}
                onClick={() =>
                  setState({
                    ...state,
                    selectedListItem: index,
                    currentPosition: positions.indexOf(
                      positions.find((item) => item.id === roulage.speedAlert)
                    )
                  })
                }
              >
                <Typography variant="subtitle1" style={{ color: '#bb0b0b' }}>
                  {`${t('DB_SpeedAlert')}: ${speedConverter(
                    positions.find((position) => position.id === roulage.speedAlert).speed,
                    session.uniteVitesse
                  )} ${session.uniteVitesse}`}
                </Typography>
              </ListItemButton>
            </Tooltip>
          ) : null}
          {roulage.gAlert || roulage.gWarning ? (
            <Tooltip title={t('FR_Details_Friction')} placement="top" key={`g-${index}`}>
              <ListItemButton
                selected={state.selectedListItem === index}
                onClick={() =>
                  setState({
                    ...state,
                    selectedListItem: index,
                    currentPosition: roulage.gAlert
                      ? positions.indexOf(positions.find((item) => item.id === roulage.gAlert))
                      : positions.indexOf(positions.find((item) => item.id === roulage.gWarning))
                  })
                }
              >
                {roulage.gAlert ? (
                  <Typography variant="subtitle1" style={{ color: '#bb0b0b' }}>
                    {`${t('DB_GAlert')}: ${calculNbG(
                      positions.find((position) => position.id === roulage.gAlert)
                    )}`}
                  </Typography>
                ) : (
                  <Typography variant="subtitle1" style={{ color: '#FF9966' }}>
                    {`${t('DB_GWarning')}: ${calculNbG(
                      positions.find((position) => position.id === roulage.gWarning)
                    )}`}
                  </Typography>
                )}
              </ListItemButton>
            </Tooltip>
          ) : null}
          <Divider />
        </Fragment>
      ))}
    </List>
  );
}
